<template>
    <div class="reports">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                    <inertia-link :href="'/backoffice/reports'" class="name">
                        <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                        {{ $page.props.lang.back || "Reports" }}
                    </inertia-link>
               / {{ $page.props.lang.membersVisits || "Members visits" }}</h2>
            </div>
        </div>
        <div class="table-header">
            <div class="pickers">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.fromDate || 'From date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="fromDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="fromDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="fromDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="fromDate" :max="toDate"
                        :first-day-of-week="1" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.toDate || 'To date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="toDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="toDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="toDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="toDate" :min="fromDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn @click="filterByDates" color="primary" height="38">{{ $page.props.lang.apply || 'Apply' }}</v-btn>
            </div>
        </div>
         <div class="export-btn">
                <v-tooltip bottom open-delay="400">
                    <template v-slot:activator="{on, attrs}">
                        <v-btn @click="exportVisits" color="primary" fab x-small outlined v-bind="attrs" v-on="on">
                            <v-icon>mdi-file-excel-box</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $page.props.lang.export || 'Export' }}</span>
                </v-tooltip>
            </div>
        <div class="table-container with-avatar">
            <v-data-table
            :headers="membersHeaders"
            :items="members.data"
            :server-items-length="members.total"
            :page.sync="tablePage"
            @page-count="tablePageCount = $event"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @update:sort-desc="sortTable"
            @update:sort-by="sortTable"
            item-key="item.id"
            mobile-breakpoint="0"
            :items-per-page="members.per_page"
            hide-default-footer>
                <template v-slot:item.first_name="{ item }">
                    <div class="name-medium">
                        <inertia-link :href="'/backoffice/members/details/'+item.id +'/visits'" class="name">
                        <v-avatar size="40">
                            <img :src="item.profile_photo_url + '?w=80'" alt="">
                        </v-avatar>
                        {{ item.first_name }} {{ item.last_name }}
                        </inertia-link>
                    </div>
                </template>
                <template v-slot:item.visit_count="{ item }">
                    <p class="amount">
                        {{ Number(item.visit_count).toFixed(2) }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>
                    </p>
                </template>
                  <template v-slot:item.avg_visit="{ item }">
                       <span v-if="item.avg_visit > 0"> {{ item.avg_visit | toHours}}</span>
                       <span v-if="item.avg_visit == 0">00:00</span>
                </template>
                <template v-slot:item.week_avg="{ item }">
                       <span> {{ item.week_avg}}</span>
                </template>


            </v-data-table>
        </div>
        <pagination :links="members.links" />
    </div>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'
import Pagination from '@/js/Components/Pagination'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Members Visits Report"
        }
    },
    layout: AppLayout,
    components: {Pagination},
    props: {
        members: Object,
        filters: Object,
        total_visits: Number,
        lang: Object,
        dateFrom: String,
        dateTo: String
    },
    data(){
        return {
            date: moment().format('YYYY-MM-DD'),
            fromDatePicker: false,
            fromDate: moment(this.dateFrom).format('YYYY-MM-DD'),
            toDatePicker: false,
            toDate: moment(this.dateTo).format('YYYY-MM-DD'),
            membersHeaders: [
                {text: this.lang.fullName || 'Full name', value: 'first_name', align: 'start'},
                {text: this.lang.visitCount || 'Visit count', value: 'visits_count', align: 'center', sortable: false},
                {text: this.lang.avgVisit || 'Average Visits', value: 'avg_visit', align: 'center', sortable: false},
                {text: this.lang.avgWeek || 'Week Average', value: 'week_avg', align: 'center', sortable: false},
            ],
            tablePageCount: 0,
            tablePage: 1,
            sortBy: [],
            sortDesc: [],
            page: null
        }
    },
    created() {
        this.initPageAndSort()
    },
    methods: {

         initPageAndSort() {
            let pageUrl = new URLSearchParams(window.location)
            let sortDesc = pageUrl.get('order')
            let sortBy = pageUrl.get('sort')
            let page = pageUrl.get('page')
            this.page = page ? page : null
            sortBy ? this.sortBy[0] = sortBy : ''
            if (sortDesc) {
                sortDesc==='asc' ? this.sortDesc[0] = false : this.sortDesc[0] = true
            }
        },

        sortTable() {

            let order = this.sortDesc[0]===false ? 'asc' : 'desc'
            let data = {}
            if (this.page!==null) { data.page = this.page}
            if (this.sortDesc.length>0) { 
                data.order = order
                data.sort = this.sortBy[0]
            }
            this.$inertia.visit('/backoffice/reports/visits', { 
                only: ['members'], 
                preserveState: true, 
                data: data
            })
        },

        filterByDates() {
            this.$inertia.visit(
                '/backoffice/reports/visits?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate, 
                {only:['members', 'total_visits', 'dateTo', 'dateFrom']}
            )
        },
        exportVisits(){
                window.location.href = '/backoffice/reports/visits/export?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate,
                    {only:['members', 'total_visits', 'dateTo', 'dateFrom']}
            }
        }
        
    }


</script>